export const PLAY_SOUND_FX = 'Play Sound Effects'; // params: soundType, trigger
